import React, { createContext, useContext, useState } from "react";

const GuidedSetupBusinessContext = createContext();

export const GuidedSetupBusinessProvider = ({ children }) => {
  const [guidedSetupBusinessData, setGuidedSetupBusinessData] = useState({
    name: "",
    website: "",
    address: "",
    country: "",
    overview: "",
    businessHours: [
      { day: "Monday", from: "09:00 AM", to: "05:30 PM", open: true },
      { day: "Tuesday", from: "09:00 AM", to: "05:30 PM", open: true },
      { day: "Wednesday", from: "09:00 AM", to: "05:30 PM", open: true },
      { day: "Thursday", from: "09:00 AM", to: "05:30 PM", open: true },
      { day: "Friday", from: "09:00 AM", to: "05:30 PM", open: true },
      { day: "Saturday", from: "", to: "", open: false },
      { day: "Sunday", from: "", to: "", open: false },
    ],
    timezone: "Central Time",
    coreServices: [],
    direction: "",
  });

  const updateBusinessData = (value) => {
    setGuidedSetupBusinessData(value);
  };

  return (
    <GuidedSetupBusinessContext.Provider
      value={{ guidedSetupBusinessData, updateBusinessData }}
    >
      {children}
    </GuidedSetupBusinessContext.Provider>
  );
};

export const useGuidedSetupBusinessContext = () => {
  const context = useContext(GuidedSetupBusinessContext);
  if (!context) {
    throw new Error(
      "useGuidedSetupBusinessContext must be used within GuidedSetupBusinessProvider"
    );
  }
  return context;
};
export { GuidedSetupBusinessContext };
